import { render } from "./KPIPerformanceChart.vue?vue&type=template&id=672c187f&scoped=true"
import script from "./KPIPerformanceChart.vue?vue&type=script&lang=js"
export * from "./KPIPerformanceChart.vue?vue&type=script&lang=js"

import "./KPIPerformanceChart.vue?vue&type=style&index=0&id=672c187f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672c187f"]])

export default __exports__